export enum Questions {
  YES = "1",
  NO = "0",
}
